import { render, staticRenderFns } from "./LogoBox.vue?vue&type=template&id=06e0dcf8&scoped=true&"
import script from "./LogoBox.vue?vue&type=script&lang=js&"
export * from "./LogoBox.vue?vue&type=script&lang=js&"
import style0 from "./LogoBox.vue?vue&type=style&index=0&id=06e0dcf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e0dcf8",
  null
  
)

export default component.exports